import { render, staticRenderFns } from "./BasicCustomerInquiry.vue?vue&type=template&id=4014fede&scoped=true"
import script from "./BasicCustomerInquiry.vue?vue&type=script&lang=js"
export * from "./BasicCustomerInquiry.vue?vue&type=script&lang=js"
import style0 from "./BasicCustomerInquiry.vue?vue&type=style&index=0&id=4014fede&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4014fede",
  null
  
)

export default component.exports